import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"700px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "rk-modal-title" }
const _hoisted_5 = {
  key: 0,
  class: "rk-intro"
}
const _hoisted_6 = { class: "rk-intro" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "rk-rw-name" }
const _hoisted_9 = { class: "rk-seg" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "rk-clear"
}
const _hoisted_12 = {
  key: 1,
  class: "rk-hint",
  style: {"margin-top":"10px"}
}
const _hoisted_13 = { class: "rk-intro" }
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  class: "rk-chip"
}
const _hoisted_16 = { class: "rk-chip" }
const _hoisted_17 = {
  key: 0,
  class: "rk-hint"
}
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "rk-actions" }
const _hoisted_22 = {
  key: 0,
  class: "rk-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " → " + _toDisplayString(_ctx.quarterLabel(_ctx.next)), 1),
      (!_ctx.loaded)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Loading…"))
        : (_ctx.step == 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode("Step 1 of 2: close out " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + ". Decide what happens to every rock that isn't done.", 1),
                (_ctx.doneCount)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.doneCount) + " already done.", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.open, (r) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: r.ID,
                  class: "rk-rw"
                }, [
                  _createElementVNode("span", {
                    class: "rk-own",
                    title: _ctx.ownerName(r.OwnerEmployeeID)
                  }, _toDisplayString(_ctx.initials(_ctx.ownerName(r.OwnerEmployeeID))), 9, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("b", null, _toDisplayString(r.Name), 1),
                    _createElementVNode("span", null, _toDisplayString(r.Milestones.filter(m => m.Done).length) + "/" + _toDisplayString(r.Milestones.length) + " milestones · " + _toDisplayString(r.Status == 'off' ? 'off track' : 'on track'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DECISIONS, (d) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: d.value,
                        type: "button",
                        class: _normalizeClass(_ctx.decisions[r.ID] == d.value ? 'on' : ''),
                        onClick: ($event: any) => (_ctx.decisions[r.ID] = d.value)
                      }, _toDisplayString(d.label), 11, _hoisted_10))
                    }), 128))
                  ])
                ]))
              }), 128)),
              (!_ctx.open.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Every " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)) + " rock you can update is already done or decided.", 1))
                : _createCommentVNode("", true),
              (_ctx.decidedCount)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.decidedCount) + " decided: " + _toDisplayString(_ctx.countOf('done')) + " done, " + _toDisplayString(_ctx.countOf('carry')) + " carried forward, " + _toDisplayString(_ctx.countOf('drop')) + " let go. ", 1),
                    _createElementVNode("a", {
                      class: "rk-link",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.decisions = {}), ["prevent"]))
                    }, "Undo All")
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("p", _hoisted_13, "Step 2 of 2: set " + _toDisplayString(_ctx.quarterLabel(_ctx.next)) + " rocks, 3 to 7 per team. Carried rocks are already in.", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextRocks, (r) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: r.ID,
                  class: "rk-rwn"
                }, [
                  _createElementVNode("span", {
                    class: "rk-own",
                    title: _ctx.ownerName(r.OwnerEmployeeID)
                  }, _toDisplayString(_ctx.initials(_ctx.ownerName(r.OwnerEmployeeID))), 9, _hoisted_14),
                  _createElementVNode("b", null, _toDisplayString(r.Name), 1),
                  (r.CarriedFromRockID)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Carried"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(r.Team ? _ctx.teamLabel(r.Team) : 'No team'), 1)
                ]))
              }), 128)),
              (!_ctx.nextRocks.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, "No rocks yet."))
                : _createCommentVNode("", true),
              (_ctx.teams.length)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    class: "rk-rwadd",
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.addRock()), ["prevent"]))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newRock.Name) = $event)),
                      placeholder: 'New rock for ' + _ctx.quarterLabel(_ctx.next),
                      ref: "newRockInput"
                    }, null, 8, _hoisted_18), [
                      [_vModelText, _ctx.newRock.Name]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newRock.OwnerEmployeeID) = $event)),
                      "aria-label": "Owner"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: e.ID,
                          value: e.ID
                        }, _toDisplayString(e.Name), 9, _hoisted_19))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.newRock.OwnerEmployeeID]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newRock.Team) = $event)),
                      "aria-label": "Team"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (t) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: t,
                          value: t
                        }, _toDisplayString(_ctx.teamLabel(t)), 9, _hoisted_20))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.newRock.Team]
                    ]),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn", _ctx.adding ? 'disable-button' : ''])
                    }, "Add", 2)
                  ], 32))
                : _createCommentVNode("", true),
              _cache[9] || (_cache[9] = _createElementVNode("p", {
                class: "rk-hint",
                style: {"margin-top":"8px"}
              }, "Add milestones to each rock from the Rocks tab once the list is final.", -1))
            ], 64)),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.step == 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", {
                class: "btn-light",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
              }, "Save for Later"),
              _cache[10] || (_cache[10] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
              (_ctx.undecided)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Decide " + _toDisplayString(_ctx.undecided) + " more first", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["btn", _ctx.undecided || _ctx.applying ? 'disable-button' : '']),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.applyDecisions()))
              }, "Next: Set " + _toDisplayString(_ctx.quarterLabel(_ctx.next)) + " Rocks", 3)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('finish', _ctx.next)))
              }, "Done, Show " + _toDisplayString(_ctx.quarterLabel(_ctx.next)), 1)
            ], 64))
      ])
    ])
  ]))
}